import { ColumnsType } from 'antd/es/table';

import { LimitSchema } from '@app/models/products';
import { formatDateAndTime } from '@app/services/date';

export const BASE_COLUMNS_WIP: ColumnsType<LimitSchema> = [
  {
    title: 'limits.tableColumns.owner',
    dataIndex: 'limit_owner_name',
    key: 'limit_owner_name',
    ellipsis: true,
  },
  {
    title: 'limits.tableColumns.createdAt',
    dataIndex: 'created_at',
    key: 'created_at',
    ellipsis: true,
    render: (_, limit) => (limit.created_at ? formatDateAndTime(limit.created_at) : ''),
  },
  {
    title: 'limits.tableColumns.items',
    dataIndex: 'items',
    key: 'items',
    ellipsis: true,
    render: (_, limit) => limit.items?.length || 0,
  },
];
